<template>
  <div class="list-add">
    <!-- 添加弹框 -->
    <div class="add">
      <div class="baseInfo">
        <div class="baseInfoContent">
          <el-form :model="modifyData" label-width="120px" label-position="right" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <!-- v-loading="loading" -->
            <div-border label="基础信息" prop="plan" v-if="editType === 0">
              <el-form-item label="运输方式：" prop="clause" style="margin-top: 15px">
                <el-radio-group v-model="modifyData.clause" @change="clauseChange">
                  <el-radio label="1">公路</el-radio>
                  <el-radio label="2">水路</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="线路选择：" prop="line">
                    <el-select v-model="modifyData.line" filterable style="width: 100%" size="small" placeholder="请选择线路" value-key="id">
                      <el-option v-for="item in lineOption" :key="item.id" :label="item.line_name" :value="item"></el-option>
                    </el-select>
                    <div v-if="modifyData.line.line_name && modifyData.line.line_name != ''">
                      <el-row style="color: rgb(153, 153, 153); font-size: 12px; line-height: 18px; margin-bottom: 3px">
                        <el-col v-if="!modifyData.line.departure_port_id" :span="24"> 起始地：{{ modifyData.line.start_address_name }} </el-col>
                        <el-col v-else :span="24"> 起始地：{{ modifyData.line.start_address_name }}【{{ modifyData.line.departure_port }}】 </el-col>
                      </el-row>
                      <el-row style="color: rgb(153, 153, 153); font-size: 12px; line-height: 18px">
                        <el-col v-if="!modifyData.line.arrive_port_id" :span="24"> 终止地：{{ modifyData.line.end_address_name }} </el-col>
                        <el-col v-else :span="24"> 终止地：{{ modifyData.line.end_address_name }}【{{ modifyData.line.arrive_port }}】 </el-col>
                      </el-row>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="委托商：" prop="entrust">
                    <el-select v-model="modifyData.entrust" style="width: 100%" filterable size="small" placeholder="请选择委托商" @change="getEntrust">
                      <el-option v-for="item in consignorOption" :key="item.id" :label="item.customer_name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-form-item label="合同编号：" prop="contract">
                  <el-input size="small" v-model="modifyData.contract.codeNumber" disabled @click.native="contractClick" placeholder="未选择"/>
                  <div v-if="modifyData.contract && modifyData.contract.codeNumber!=''">
                    <el-row style="color: rgb(153, 153, 153);font-size: 12px;line-height: 18px;margin-bottom: 3px;">
                      <el-col :span="24">委托商：{{ modifyData.contract.companyName }}</el-col>
                    </el-row>
                  </div>
                </el-form-item> -->
            </div-border>
            <div style="padding: 15px 0" class="basicsStyle">
              <div-border label="价格设置" style="padding: 29px 20px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="适配车型：" prop="model">
                      <cascader ref="cascader" :options="modelOption" :props="props" :filed="'model'" @getValue="getValue" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="editType === 0">
                  <el-col :span="24">
                    <el-form-item label="税率：" prop="taxRate">
                      <el-input size="small" v-model="modifyData.taxRate" placeholder="请输入税率" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="editType === 0">
                  <el-col :span="24">
                    <el-form-item label="结算价设置：">
                      <el-row>
                        <el-col :span="12">
                          <span class="item-span">{{ modifyData.priceType == 1 ? '合同价' : modifyData.priceType == 2 ? '预结算价' : '未设置' }}</span>
                        </el-col>
                        <el-col :span="12">
                          <span class="item-span">{{ modifyData.priceType && modifyData.priceType != 0 ? '价格：' + modifyData.price : '' }}</span>
                          <span class="set-up" @click="priceSetBtn">设置</span>
                        </el-col>
                      </el-row>
                      <el-row v-if="modifyData.companyName || modifyData.codeNumber">
                        <el-col :span="12">
                          <span class="item-span">合同名称：{{ modifyData.companyName }}</span>
                        </el-col>
                        <el-col :span="12">
                          <span class="item-span">合同编号：{{ modifyData.codeNumber }}</span>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="editType === 0">
                  <el-col :span="24">
                    <el-form-item label="预估价：" prop="estimatePrice">
                      <el-input size="small" v-model="modifyData.estimatePrice" placeholder="请输入预估价" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="editType === 0">
                  <el-col :span="12">
                    <el-form-item label="开始时间：" prop="startTime">
                      <el-date-picker v-model="modifyData.startTime" style="width: 100%" size="small" type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" @change="validityTimeChange"> </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="结束时间:" prop="endTime">
                      <el-date-picker v-model="modifyData.endTime" style="width: 100%" size="small" type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange" default-time="23:59:59"> </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <div>
                  <el-table
                    :data="modifyData.lineIncome"
                    v-loading="tableLoad"
                    style="width: 100%"
                    border
                    :header-cell-style="{color:'#3B3B3B','font-size':'13px',height:'35px',background:'#E8E8E8',}"
                    :cell-style="{ color:'#7F7F7F','font-size':'13px' }"
                    :header-cell-class-name="cellStyle"
                    tooltip-effect="dark"
                    ref="carTableRef">
                    <el-table-column type="index" width="50" align="center" label="序号"/>
                    <el-table-column label="车型" min-width="150" prop="model" align="center">
                      <template slot-scope="scope">
                        <el-form-item label-width="0px" :prop="`lineIncome[${scope.$index}].model`" :rules="rules.model">
                          <el-cascader size="mini" style="width:100%" v-model="scope.row.model"
                            placeholder="请选择" :options="modelOption"
                            :props="props" collapse-tags clearable filterable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="税率%" min-width="100" prop="taxRate" align="center">
                      <template slot-scope="scope">
                        <el-form-item label-width="0px" :prop="`lineIncome[${scope.$index}].taxRate`" :rules="rules.taxRate">
                          <el-input size="small" v-model="scope.row.taxRate" placeholder="请输入税率"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="价格方式" min-width="120" prop="contractPrice" align="center">
                      <template slot-scope="scope">
                        <el-radio v-model="scope.row.priceType" :label="'1'">合同价格</el-radio>
                        <el-radio v-model="scope.row.priceType" :label="'2'">预结算价格</el-radio>
                      </template>
                    </el-table-column>
                    <el-table-column label="价格" min-width="230" align="center">
                      <template slot-scope="scope">
                        <div style="width:50%;display:inline-block;padding-top: 7px;vertical-align: top;">
                          <el-radio v-model="scope.row.priceType" :label="'1'">合同价格</el-radio>
                          <el-radio v-model="scope.row.priceType" :label="'2'">预结算价格</el-radio>
                        </div>
                        <el-form-item style="width:50%;display:inline-block" v-if="scope.row.priceType==1" label-width="0px" :prop="`lineIncome[${scope.$index}].contractPrice`" :rules="rules.contractPrice">
                          <el-input size="small" v-model="scope.row.contractPrice" placeholder="合同价格">
                            <i slot="suffix" class="input-right">元</i>
                          </el-input>
                        </el-form-item>
                        <el-form-item style="width:50%;display:inline-block" v-if="scope.row.priceType==2" label-width="0px" :prop="`lineIncome[${scope.$index}].preparePrice`" :rules="rules.preparePrice">
                          <el-input size="small" v-model="scope.row.contractPrice" placeholder="预结算价格">
                            <i slot="suffix" class="input-right">元</i>
                          </el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="预结算方式" prop="prepareType" align="center" width="130">
                      <template slot-scope="scope">
                        <el-form-item label-width="0px" class="prepareType" style="margin-bottom:5px !important;">
                          <el-radio-group v-model="scope.row.prepareType">
                            <el-radio label="1" style="margin-right:0">固定</el-radio>
                            <el-radio label="2" style="margin-right: 0">比例</el-radio>
                          </el-radio-group>
                          <el-input size="small" v-model="scope.row.prepareTypePrice">
                            <i slot="suffix" class="input-right">{{scope.row.prepareType==="2"?"%":"元"}}</i>
                          </el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>

                    <el-table-column label="结算价格设置" min-width="120" prop="taxRate" align="center">
                      <template slot-scope="scope">
                        <p>
                          <span>{{scope.row.priceType==1?'合同价:':(scope.row.priceType==2?'预结算价:':'未设置')}}</span>
                          <span v-if="scope.row.priceType==1||scope.row.priceType==2">{{scope.row.contractPrice}}</span>
                        </p>
                        <span class="set-up" @click="priceSetBtn(scope.$index)">设置</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="预估价格" min-width="100" prop="estimatePrice" align="center">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          :prop="`lineIncome[${scope.$index}].estimatePrice`"
                          :rules="rules.estimatePrice">
                          <el-input size="small" v-model="scope.row.estimatePrice" placeholder="预估价格"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="50">
                      <i
                        class="el-icon-error"
                        style="font-size: 20px; cursor: pointer"
                        slot-scope="scope"
                        @click="deleteTable(scope.$index)"
                      ></i>
                    </el-table-column>
                    <div slot="append" style="padding: 9px">
                      <el-button
                        type="warning"
                        icon="el-icon-plus"
                        circle
                        style="padding: 4px"
                        @click="addMaterial"
                      >
                      </el-button>
                      <span style="margin: 10px">添加</span>
                    </div>
                  </el-table>
                </div> -->
              </div-border>
            </div>
            <div>
              <div-border label="合同设置" style="padding: 29px 20px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="合同：" prop="contract">
                      <el-select v-model="modifyData.contract" filterable style="width: 100%" size="mini" placeholder="请选择合同" value-key="id">
                        <el-option v-for="item in contractOption" :key="item.id" :label="item.name" :value="item"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div-border>
            </div>
          </el-form>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="medium" :loading="loading" @click="addClick">
            {{ this.dataD.showNumber === 1 ? '添加' : '修改' }}
          </el-button>
          <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
        </div>
      </div>
    </div>

    <!-- 修改弹框 -->
    <!-- <div class="add" v-else>
      <div class="baseInfo">
        <div class="baseInfoContent">
          <el-form :model="modifyData" label-width="120px" label-position="right"
            :rules="rules" ref="ruleForm" class="demo-ruleForm" v-loading="loading" >
            <div-border label="基础信息" prop="plan">
              <div class="yang">
                <el-form-item label="运输方式：" prop="clause" style="margin-top: 15px">
                  <el-radio-group v-model="modifyData.clause" @change="clauseChange">
                    <el-radio label="1">公路</el-radio>
                    <el-radio label="2">水路</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="线路选择：" prop="line">
                  <el-select v-model="modifyData.line" filterable size="small" placeholder="请选择线路" value-key="id">
                    <el-option v-for="(item) in lineOption" :key="item.id" :label="item.line_name" :value="item"></el-option>
                  </el-select>
                  <div v-if="modifyData.line.line_name && modifyData.line.line_name!=''">
                    <el-row style="color: rgb(153, 153, 153);font-size: 12px;line-height: 18px;margin-bottom: 3px;">
                      <el-col v-if="!modifyData.line.departure_port_id" :span="24">起始地：{{ modifyData.line.start_address_name }}</el-col>
                      <el-col v-else :span="24">起始地：{{modifyData.line.start_address_name}}【{{modifyData.line.departure_port}}】</el-col>
                    </el-row>
                    <el-row style="color: rgb(153, 153, 153);font-size: 12px;line-height: 18px;">
                      <el-col v-if="!modifyData.line.arrive_port_id" :span="24">终止地：{{ modifyData.line.end_address_name }}</el-col>
                      <el-col v-else :span="24">终止地：{{modifyData.line.start_address_name}}【{{modifyData.line.arrive_port}}】</el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <el-form-item label="合同编号：" prop="contract">
                  <el-input size="small" v-model="modifyData.contract.codeNumber" disabled @click.native="contractClick" placeholder="未选择"/>
                  <div v-if="modifyData.contract && modifyData.contract.codeNumber!=''">
                    <el-row style="color: rgb(153, 153, 153);font-size: 12px;line-height: 18px;margin-bottom: 3px;">
                      <el-col :span="24">委托商：{{ modifyData.contract.companyName }}</el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="开始时间：" prop="startTime">
                      <el-date-picker
                        v-model="modifyData.startTime"
                        style="width: 100%"
                        size="small"
                        type="datetime"
                        placeholder="选择开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="validityTimeChange"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item
                      label="结束时间:"
                      prop="endTime"
                      label-width="85px"
                    >
                      <el-date-picker
                        v-model="modifyData.endTime"
                        style="width: 100%"
                        size="small"
                        type="datetime"
                        placeholder="选择结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="timeChange"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div-border>

            <div style="padding: 15px 0" class="basicsStyle">
              <div-border label="价格设置" style="padding: 29px 20px">
                <div>
                  <el-table
                    :data="modifyData.lineIncome"
                    v-loading="tableLoad"
                    style="width: 100%"
                    ref="contractTable"
                    border
                    :header-cell-style="{
                      color: '#3B3B3B',
                      'font-size': '13px',
                      height: '35px',
                      background: '#E8E8E8',
                    }"
                    :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }"
                    :header-cell-class-name="cellStyle"
                    tooltip-effect="dark"
                    ref="carTableRef">
                    <el-table-column type="index" width="50" align="center" label="序号"/>
                    <el-table-column label="车型" min-width="150" prop="model" align="center">
                      <template slot-scope="scope">
                        <el-form-item label-width="0px" :prop="`lineIncome[${scope.$index}].model`" :rules="rules.model">
                          <el-cascader size="mini" style="width:100%" v-model="scope.row.model"
                            placeholder="请选择" :options="modelOption"
                            :props="props" collapse-tags clearable filterable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="税率%" min-width="100" prop="taxRate" align="center">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          :prop="`lineIncome[${scope.$index}].taxRate`"
                          :rules="rules.taxRate">
                          <el-input
                            size="small"
                            v-model="scope.row.taxRate"
                            placeholder="请输入税率">
                          </el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="价格方式" min-width="120" prop="priceType" align="center">
                      <template slot-scope="scope">
                        <el-radio v-model="scope.row.priceType" :label="'1'">合同价格</el-radio>
                        <el-radio v-model="scope.row.priceType" :label="'2'">预结算价格</el-radio>
                      </template>
                    </el-table-column>
                    <el-table-column label="价格" min-width="230" align="center">
                      <template slot-scope="scope">
                        <div style="width:50%;display:inline-block;padding-top: 7px;vertical-align: top;">
                          <el-radio v-model="scope.row.priceType" :label="'1'">合同价格</el-radio>
                          <el-radio v-model="scope.row.priceType" :label="'2'">预结算价格</el-radio>
                        </div>
                        <el-form-item style="width:50%;display:inline-block" v-if="scope.row.priceType==1" label-width="0px" :prop="`lineIncome[${scope.$index}].contractPrice`" :rules="rules.contractPrice">
                          <el-input size="small" v-model="scope.row.contractPrice" placeholder="合同价格">
                            <i slot="suffix" class="input-right">元</i>
                          </el-input>
                        </el-form-item>
                        <el-form-item style="width:50%;display:inline-block" v-if="scope.row.priceType==2" label-width="0px" :prop="`lineIncome[${scope.$index}].preparePrice`" :rules="rules.preparePrice">
                          <el-input size="small" v-model="scope.row.contractPrice" placeholder="预结算价格">
                            <i slot="suffix" class="input-right">元</i>
                          </el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="结算价格设置" min-width="120" prop="taxRate" align="center">
                      <template slot-scope="scope">
                        <p>
                          <span>{{scope.row.priceType==1?'合同价:':(scope.row.priceType==2?'预结算价:':'未设置')}}</span>
                          <span v-if="scope.row.priceType==1||scope.row.priceType==2">{{scope.row.contractPrice}}</span>
                        </p>
                        <span class="set-up" @click="priceSetBtn(scope.$index)">设置</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="预估价格" prop="estimatePrice" align="center">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          :prop="`lineIncome[${scope.$index}].estimatePrice`"
                          :rules="rules.estimatePrice">
                          <el-input size="small" v-model="scope.row.estimatePrice" placeholder="预估价格"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div-border>
            </div>
          </el-form>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" :loading="loading" @click="addClick">修改</el-button>
          <el-button class="resetBtn" @click="dialogClose">关闭</el-button>
        </div>
      </div>
    </div> -->

    <!-- 选择合同编号 -->
    <!--    <el-dialog title='选择合同编号' :visible.sync='contractVisible' :close-on-click-modal='false'-->
    <!--               append-to-body width='910px'>-->
    <!--      <div class='nav'>-->
    <!--        <div class='navContainer'>-->
    <!--          <p>合同编号：</p>-->
    <!--          <el-input v-model='condition.codeNumber' size='mini' style='width:150px'-->
    <!--                    placeholder='请输入合同编号' />-->
    <!--        </div>-->
    <!--        <div class='navContainer'>-->
    <!--          <p>合同名称：</p>-->
    <!--          <el-input v-model='condition.contractName' size='mini' style='width:150px'-->
    <!--                    placeholder='请输入合同名称' />-->
    <!--        </div>-->
    <!--        <div class='navContainer'>-->
    <!--          <p>签约单位：</p>-->
    <!--          <el-input v-model='condition.companyName' size='mini' style='width:150px;margin-top: 10px'-->
    <!--                    placeholder='请输入签约单位' />-->
    <!--        </div>-->
    <!--        <div class='navBtn' style="margin-left: 50px;width: 120px">-->
    <!--          <el-button size='small' class='searchBtn' @click='_contractPageList'>查询</el-button>-->
    <!--          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <el-table :data='contractData' highlight-current-row border ref='contractTable'-->
    <!--                @current-change='contractChange' v-loading='contractLoad'-->
    <!--                :header-cell-style="{color:'#3B3B3B','font-weight':'700','padding':'0px','font-size':'13px',height:'35px',background:'#E8E8E8',}"-->
    <!--                :cell-style="{ color:'#7F7F7F','font-size':'13px' }">-->
    <!--        <el-table-column type='index' width='50' />-->
    <!--        <el-table-column property='codeNumber' label='合同编号' min-width='150' align='center' />-->
    <!--        <el-table-column property='contractName' label='合同名称' min-width='150' align='center' />-->
    <!--        <el-table-column property='typeName' label='合同类型' min-width='100' align='center' />-->
    <!--        <el-table-column property='companyName' label='签约单位' min-width='150' align='center' />-->
    <!--        <el-table-column property='startDate' label='开始日期' min-width='100' :formatter='getDate'-->
    <!--                         align='center' />-->
    <!--        <el-table-column property='endDate' label='结束日期' min-width='100' :formatter='getDate'-->
    <!--                         align='center' />-->
    <!--      </el-table>-->
    <!--      <div style='margin-top: 20px'>-->
    <!--        <el-pagination-->
    <!--          background-->
    <!--          :page-sizes='[10, 20, 30, 40]'-->
    <!--          layout='total, sizes, prev, pager, next, jumper'-->
    <!--          :total='total'-->
    <!--          @size-change='contractSizeChange'-->
    <!--          @current-change='contractCurrentChange'-->
    <!--          :current-page.sync='page'-->
    <!--          :page-size='rows'-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div slot='footer' class='dialog-footer'>-->
    <!--        <el-button size='small' @click='contractVisible = false'>取消</el-button>-->
    <!--        <el-button size='small' type='primary' @click='contractConfirm'>确定</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <!-- 结算价格设置 -->
    <el-dialog title="结算价格设置" :visible.sync="priceSetVisible" :close-on-click-modal="false" append-to-body width="910px">
      <div-border label="价格设置">
        <el-form :model="priceSetForm" label-width="100px">
          <el-form-item label="结算方式：" style="margin-top: 15px">
            <span style="display: inline-block; width: 320px">
              <el-radio-group v-model="priceSetForm.type" @change="typeChange">
                <el-radio :label="0">未设置</el-radio>
                <el-radio :label="1">合同价格</el-radio>
                <el-radio :label="2">预结算价格</el-radio>
              </el-radio-group>
            </span>
            <span style="display: inline-block; width: calc(100% - 320px); text-align: right; padding-right: 15px">
              <el-input size="small" v-if="priceSetForm.type !== 0" v-model="priceSetForm.price" placeholder="请输入价格" style="width: calc(100% - 150px); margin-right: 10px" />
              <el-button size="small" class="searchBtn" @click="priceSetConfirm">确定</el-button>
              <el-button size="small" class="resetBtn" @click="priceSetVisible = false">取消</el-button>
            </span>
          </el-form-item>
        </el-form>
      </div-border>
    </el-dialog>

    <PDFPreview ref="PDFPreviewRef" />
    <el-dialog :visible.sync="dialogVisible" append-to-body title="图片查看" center>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
  import { baseImgUrl, baseUrl } from '@/config/env';
  import uploadImg from '@/components/uploadImg';
  import divBorder from '@/components/divBorder';
  import cascader from '@/components/cascader';
  import { publicSelectLine } from '@/service/vehiclelog';
  import { contractPageList, customerInfoSelectList, getCarSerieList, lineAddConsignorLine, lineUpdateConsignorLine } from '@/service/financial';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import PDFPreview from '@/components/PDFPreview';

  export default {
    components: {
      uploadImg,
      divBorder,
      cascader,
      PDFPreview,
    },
    props: ['dataD', 'addType', 'editType'],
    data() {
      return {
        modifyData: {
          clause: '1', //运输条款
          line: {
            //线路设置
            id: '',
            line_name: '',
            start_address_name: '',
            departure_port: '',
            departure_port_id: '',
            arrive_port: '',
            arrive_port_id: '',
            end_address_name: '',
          },
          entrust: '', // 委托商
          startTime: '', // 有效期始
          endTime: '', // 结束时间
          model: [], // 适配车型
          taxRate: '', // 税率
          priceType: '', // 结算类型
          price: '', // 结算价格
          contract: '', //合同
          companyId: '', // 合同id
          companyName: '', // 合同名称
          codeNumber: '', // 合同编号
          estimatePrice: '', // 预估价
        },
        // 合同编号弹窗 数据
        condition: {
          codeNumber: '',
          contractName: '',
          companyName: '',
        },
        contractOption: [],
        contractVisible: this.addType,
        contractLoad: false,
        contractData: [],
        selectContract: {
          id: '',
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        // 结算价格设置弹窗 数据
        priceSetForm: {
          type: 0,
          price: '',
        },
        priceSetVisible: this.addType,
        //总数据条数
        total: 0,
        //当前页数
        page: 1,
        //每页显示多少条数据
        rows: 10,
        limit: 10,
        lineOption: [
          {
            name: 'sdf',
            id: '9384',
          },
        ],
        consignorOption: [],
        modelOption: [],
        modelMap: new Map(),
        brandMap: new Map(),
        lineIncome: [
          {
            // consignor:'',
            model: '',
            taxRate: '',
            contractPrice: '',
            preparePrice: '税率',
            estimatePrice: '88',
          },
        ],
        loading: false,
        operationData: [
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '启用',
            account: '王三文',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '禁用',
            account: '张三丰',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '添加',
            account: '赵兮雪',
            remark: '',
          },
        ],
        tableLoad: false,
        props: {
          value: 'id',
          label: 'model',
          children: 'carModel',
          multiple: true,
        },
        rules: {
          clause: {
            required: true,
            message: '请选择运输方式',
            trigger: 'blur',
          },
          taxRate: {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
          line: {
            required: true,
            message: '请选择线路',
            trigger: 'blur',
          },
          model: {
            required: true,
            message: '请选择车型',
            trigger: 'blur',
          },
          startTime: {
            required: true,
            message: '请选择开始时间',
            trigger: 'blur',
          },
          endTime: {
            required: true,
            message: '请选择结束时间',
            trigger: 'blur',
          },
          entrust: {
            required: true,
            message: '请选择委托商',
            trigger: 'blur',
          },
          contract: {
            required: true,
            message: '请选择合同',
            trigger: 'blur',
          },
        },
        dialogVisible: false,
        dialogImageUrl: '',
      };
    },
    filters: {
      transportTypeFormat(value) {
        switch (value) {
          case 1:
            return '公路';
          case 2:
            return '水路';
        }
      },
    },
    mounted() {
      this._getCarSerieList();
    },
    methods: {
      handlePictureCardPreview(item) {
        if (item.attachments && item.attachments[0]) {
          let token = getSessionStore('token');
          this.dialogImageUrl = `${baseImgUrl}/web/attachmentFtp/download?attachmentId=${item.attachments[0].id}&access_token=${token}`;
          if (item.attachments[0].attachmentType === 'pdf' || item.attachments[0].attachmentType === 'PDF') {
            this.$nextTick(() => {
              this.$refs.PDFPreviewRef.loadPDF(item.attachments[0].id);
            });
            // window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.dialogImageUrl}`, '_blank');
          } else {
            this.dialogVisible = true;
          }
        } else {
          this.$message.warning('此数据暂无预览文件');
        }
      },
      // 列样式
      cellStyle(data) {
        if (data.columnIndex !== 0 && data.column.label != '操作' && data.column.label != '结算价格设置' && data.column.label != '预估价格') {
          return 'require';
        } else {
          return '';
        }
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 获取修改页面数据
      async getDetail() {
        let modelList = [];
        if (this.dataD.data.carModelList && this.dataD.data.carModelList.length > 0) {
          this.dataD.data.carModelList.forEach(item => {
            modelList.push([item.brandId, item.modelId]);
          });
        }
        this.$refs.cascader.value = modelList;
        let name = '';
        if (this.dataD.data.contract_Code != null && this.dataD.data.contract_name !== '') {
          name = this.dataD.data.contract_Code + '-' + this.dataD.data.contract_name;
        } else {
          name = null;
        }
        this.modifyData = {
          id: this.dataD.data.id,
          clause: this.dataD.data.transport_type + '',
          startTime: formatDateTime(this.dataD.data.start_date, 'yyyy-mm-dd hh:ii:ss'),
          endTime: formatDateTime(this.dataD.data.end_date, 'yyyy-mm-dd hh:ii:ss'),
          line: {
            line_name: '',
            start_address_name: '',
            end_address_name: '',
            departure_port: '',
            departure_port_id: '',
            arrive_port: '',
            arrive_port_id: '',
          },
          entrust: this.dataD.data.customer_id, // 委托商
          model: modelList, // 适配车型
          contract: {
            id: this.dataD.data.contract_id,
            name:name
          },
          taxRate: this.dataD.data.tax_rate, // 税率
          priceType: this.dataD.data.prepare_price ? '2' : this.dataD.data.contract_price ? '1' : '', // 结算类型
          price: this.dataD.data.contract_price || this.dataD.data.prepare_price, // 结算价格
          companyId: this.dataD.data.contract_id, // 合同id
          // companyName: this.dataD.data.contract_name,  // 合同名称
          // codeNumber: this.dataD.data.contract_code,    // 合同编号
          estimatePrice: this.dataD.data.estimate_price, // 预估价
          contractPrice: this.dataD.data.contract_price, // 合同价
          preparePrice: this.dataD.data.prepare_price, // 预结算价
          // lineIncome: [{
          //   model: modelList,
          //   taxRate: this.dataD.data.tax_rate,
          //   priceType: this.dataD.data.prepare_price?'2':(this.dataD.data.contract_price?'1':''),
          //   contractPrice: this.dataD.data.contract_price,
          //   preparePrice: this.dataD.data.prepare_price,
          //   estimatePrice: this.dataD.data.estimate_price
          // }]
        };
        let data = await contractPageList({ id: this.dataD.data.customer_id });
        if (data.status !== 0) return this.$message.error(data.message);
        this.contractOption = data.data;
        let res = await publicSelectLine({ type: this.dataD.data.transport_type });
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineOption = res.data;
        if (this.lineOption.length > 0) {
          this.lineOption.forEach(item => {
            if (item.id == this.dataD.data.line_id) {
              this.modifyData.line = {
                id: item.id,
                line_name: item.line_name,
                start_address_name: item.start_address_name,
                end_address_name: item.end_address_name,
                departure_port: item.departure_port,
                departure_port_id: item.departure_port_id,
                arrive_port: item.arrive_port,
                arrive_port_id: item.arrive_port_id,
              };
            }
          });
        }
      },
      async _publicSelectLine(type) {
        let res = await publicSelectLine({
          type: type,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineOption = res.data;
      },
      async _customerInfoSelectList() {
        let res = await customerInfoSelectList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.consignorOption = res.data;
      },
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item.carModel.length != 0;
        });
        this.modelOption = this.modelOption.map(item => {
          item.carModel.forEach((item, index) => {
            this.modelMap.set(item.id, item.model);
            this.brandMap.set(item.brand_id, item.brand_name);
          });
          return {
            ...item,
            model: item.brand,
          };
        });
        console.log(this.modelOption);
        this.modelOption.unshift({
          model: '全选',
          id: '全选',
        });
      },
      init() {
        this.uploadUrl = baseUrl + '/web/attachment/upload';
      },

      // 选择合同
      contractClick() {
        this.page = 1;
        this.contractVisible = true;
        this._contractPageList();
      },
      // 选择合同 —— 分页查询
      async _contractPageList() {
        let obj = {
          id: this.modifyData.entrust,
        };
        let res = await contractPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
        // this.total = res.data.total || 0;
        // console.log(this.modifyData);
        // if (this.modifyData.companyId && this.contractData.length > 0) {
        //   this.contractData.forEach(item => {
        //     if (item.id == this.modifyData.companyId) {
        //       this.$refs.contractTable.setCurrentRow(item);
        //     }
        //   });
        // }
      },
      // 重置
      resetBtn() {
        for (let key in this.condition) {
          this.condition[key] = '';
        }
      },
      contractSizeChange(rows) {
        this.rows = rows;
        this._contractPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._contractPageList();
      },
      // 合同编号 —— 选中数据
      contractChange(val) {
        this.selectContract = val;
      },
      // 合同编号 —— 确认
      contractConfirm() {
        // this.modifyData.contract = this.selectContract;
        // this.modifyData.codeNumber = this.selectContract.codeNumber;
        // this.modifyData.companyName = this.selectContract.companyName;
        // if (this.selectContract.startDate) this.modifyData.startTime = this.selectContract.startDate;
        // if (this.selectContract.endDate) this.modifyData.endTime = this.selectContract.endDate;
        this.contractVisible = false;
      },
      // 结算方式改变
      typeChange(val) {
        if (this.dataD.showNumber == 1) return false;
        if (val == 1) {
          this.priceSetForm.price = this.modifyData.contractPrice;
        }
        if (val == 2) {
          this.priceSetForm.price = this.modifyData.preparePrice;
        }
      },
      // 结算价格设置
      priceSetBtn() {
        if (!this.modifyData.entrust || this.modifyData.entrust == '') {
          return this.$message.error('请选择委托商！');
        }
        this.priceSetForm = {
          type: this.modifyData.priceType ? parseInt(this.modifyData.priceType) : 0,
          price: this.modifyData.price ? this.modifyData.price : '',
        };
        this.priceSetVisible = true;
      },
      // 结算价格设置 —— 确认
      priceSetConfirm() {
        // this.modifyData.lineIncome[this.priceSetForm.index].priceType = this.priceSetForm.type;
        // this.modifyData.lineIncome[this.priceSetForm.index].contractPrice = this.priceSetForm.price;
        if (this.priceSetForm.type == 1 && (!this.priceSetForm.price || this.priceSetForm.price == '')) {
          console.log(111, this.priceSetForm.price);
          return this.$message.warning('请输入价格！');
        }
        this.modifyData.priceType = this.priceSetForm.type;

        if (this.priceSetForm.type == 0) {
          this.modifyData.price = '';
          this.modifyData.companyId = '';
          this.modifyData.codeNumber = '';
          this.modifyData.companyName = '';
          if (this.dataD.showNumber == 1) {
            this.modifyData.startTime = '';
            this.modifyData.endTime = '';
          }
        } else {
          this.modifyData.price = this.priceSetForm.price;

          this.modifyData.companyId = this.selectContract.id;
          this.modifyData.codeNumber = this.selectContract.codeNumber;
          this.modifyData.companyName = this.selectContract.contractName;
          if (this.selectContract.startDate) this.modifyData.startTime = this.selectContract.startDate;
          if (this.selectContract.endDate) this.modifyData.endTime = this.selectContract.endDate;
        }

        this.priceSetVisible = false;
      },

      // 新增/修改确认
      addClick() {
        // console.log(this.modifyData);
        // console.log(this.dataD);
        // return;
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            let { startTime, endTime, clause, line, entrust, contract, priceType, companyId, taxRate, price, estimatePrice, model } = this.modifyData;
            if ((!price || price == '') && (!estimatePrice || estimatePrice == '')) {
              return this.$message.warning('结算价格与预估价格至少有一个值！');
            }
            this.loading = true;

            if (this.dataD.showNumber === 1) {
              //添加
              //基础价格设置
              // consignorLineBasics: this.modifyData.lineIncome==[]?[]: lineIncome.map((item) => {
              //   return {
              //     taxRate: item.taxRate,
              //     contractPrice: item.priceType==1?item.contractPrice:'',  // 合同价格
              //     preparePrice: item.priceType==2?item.contractPrice:'',   // 预结算价格
              //     estimatePrice: item.estimatePrice,
              //     carModelList: item.model.map((item) => {
              //       return {
              //         modelId: item[1],
              //         modelName: this.modelMap.get(item[1]),
              //         brandId: item[0],
              //         brandName: this.brandMap.get(item[0]),
              //       };
              //     }),
              //   }
              // }),

              let obj = {
                transportType: clause,
                lineId: line.id,
                customerId: entrust,
                contractId: contract.id,
                startDate: startTime,
                endDate: endTime,
                consignorLineBasics: [
                  {
                    taxRate: taxRate,
                    contractPrice: priceType == 1 ? price : '', // 合同价格
                    preparePrice: priceType == 2 ? price : '', // 预结算价格
                    estimatePrice: estimatePrice,
                    carModelList: model.map(item => {
                      return {
                        modelId: item[1],
                        modelName: this.modelMap.get(item[1]),
                        brandId: item[0],
                        brandName: this.brandMap.get(item[0]),
                      };
                    }),
                  },
                ],
              };

              let res = await lineAddConsignorLine(obj);
              this.loading = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
            } else {
              //修改
              let obj = {
                createByName: this.dataD.data['create_by_name'],
                id: this.modifyData.id,
                transportType: clause,
                lineId: line.id,
                customerId: entrust,
                contractId: contract.id,
                startDate: startTime,
                endDate: endTime,
                taxRate: taxRate,
                contractPrice: priceType == 1 ? price : '', // 合同价格
                preparePrice: priceType == 2 ? price : '', // 预结算价格
                estimatePrice: estimatePrice,
                carModelList: model.map(item => {
                  return {
                    modelId: item[1],
                    modelName: this.modelMap.get(item[1]),
                    brandId: item[0],
                    brandName: this.brandMap.get(item[0]),
                  };
                }),
              };
              let res = await lineUpdateConsignorLine(obj);
              this.loading = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
            }
            this.$parent.$parent._lineConsignorLineList();
            this.dialogClose();
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.modifyData = {
          clause: '1', //运输条款
          line: {
            //线路设置
            line_name: '',
            start_address_name: '',
            departure_port: '',
            departure_port_id: '',
            arrive_port: '',
            arrive_port_id: '',
            end_address_name: '',
          },
          entrust: '', // 委托商
          startTime: '', // 有效期始
          endTime: '', // 结束时间
          model: '', // 适配车型
          taxRate: '', // 税率
          contract: '',
          priceType: '', // 结算类型
          price: '', // 结算价格
          companyId: '', // 合同id
          companyName: '', // 合同名称
          codeNumber: '', // 合同编号
          estimatePrice: '', // 预估价
        };
        this.$refs.ruleForm.resetFields();
        this.$refs.cascader.value = [];
        this.$emit('addclose', false);
      },
      //添加价格
      addMaterial() {
        this.modifyData.lineIncome.push({
          model: '',
          taxRate: '',
          priceType: '',
          contractPrice: '',
          preparePrice: '',
          estimatePrice: '',
          // prepareTypePrice: "",
          // prepareType: "1",
        });
        console.log(this.modifyData.lineIncome);
      },
      deleteTable(index) {
        if (index > 0) {
          this.modifyData.lineIncome.splice(index, 1);
        }
        // this.modifyData.lineIncome.splice(index,1)
      },
      clauseChange(value) {
        this.modifyData.line = '';
        this._publicSelectLine(value);
      },
      getEntrust(value) {
        this.modifyData.contract = '';
        this._contractPageList(value);
      },
      // 判断时间大小
      getMax(date1, date2) {
        const oDate1 = new Date(date1);
        const oDate2 = new Date(date2);
        if (oDate1.getTime() > oDate2.getTime()) {
          console.log('第一个大');
          return true;
        } else {
          console.log('第二个大');
          return false;
        }
      },
      // 结束时间判断
      timeChange(value) {
        if (this.getMax(this.modifyData.startTime, value)) {
          this.$message.warning('结束时间不能小于起始时间');
          this.modifyData.endTime = '';
        }
      },
      // 起始时间判断
      validityTimeChange(value) {
        if (this.modifyData.endTime && this.getMax(value, this.modifyData.endTime)) {
          this.$message.warning('起始时间不能大于结束时间');
          this.modifyData.startTime = '';
        }
      },

      //当前默认显示多少条数据
      handleSizeChange(newSize) {
        //将最新的值赋值给this.pagesize
        this.limit = newSize;
        //重新进行请求一遍
        this.getGamelist();
      },
      getValue(filed, data, isAll) {
        let subData = JSON.parse(JSON.stringify(data));
        isAll ? subData.shift() : '';
        this.modifyData[filed] = subData;
        console.log(this.modifyData);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .list-add {
    .el-dialog__wrapper {
      top: -52px;
    }

    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
      color: #606266;
      content: '全选';
      font-size: 12px;
      margin-left: 2px;
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-form-item {
            // margin-bottom: 15px;
            margin: 0;

            .el-form-item__error {
              top: 92%;
            }
          }

          .basicsStyle {
            .el-form-item {
              // margin-top: 3px;
              // margin-bottom: 5px;
              .el-input {
                width: 100%;
              }

              .el-select {
                width: 100%;
              }
            }

            .el-form-item__error {
              top: 96%;
            }

            // .el-input__inner {
            //   height: 24px;
            //   line-height: 24px;
            // }
            // .prepareType {
            //   .el-form-item__content {
            //     // line-height: 24px;
            //   }
            // }

            .el-icon-error {
              &:hover {
                color: #00cacc;
              }
            }
          }
        }
      }

      .el-table td,
      .el-table th {
        padding: 0;
      }

      .cell {
        font-size: 13px;
        padding: 0;
        font-weight: 900;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    .el-pagination {
      margin-top: 10px;
      text-align: center;
    }
  }

  ::v-deep {
    .el-table th.require > div::before {
      content: '*';
      color: red;
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fff;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .cell .el-form-item {
      padding: 0 2px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
      text-align: center;
    }

    .el-dialog__headerbtn {
      top: 0px;
      height: 42px;
      line-height: 42px;
      right: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
    }

    .el-dialog__title {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    .el-dialog__body {
      padding: 20px !important;
      max-height: 60vh;
      overflow-y: auto;
    }

    .el-pagination {
      text-align: left !important;
    }

    .el-dialog__footer {
      text-align: right !important;
    }

    .el-form-item__content {
      line-height: 40px;
    }

    .cell .el-radio {
      margin-right: 0px;
      float: left;
      left: 10px;
    }

    .el-radio:last-child {
      margin-top: 3px;
    }
  }

  .list-add .add::v-deep {
    .cell p {
      display: inline-block;
      font-size: 13px;
      width: 100%;
      padding: 0 42px 0 5px;
      text-align: left;
    }
  }

  .item-span {
    font-size: 13px;
  }

  .set-up {
    color: #3187ff;
    position: absolute;
    // width: 26px !important;
    padding-right: 10px;
    height: 24px;
    line-height: 24px;
    right: 10px;
    top: calc(50% - 12px);
    text-decoration: underline;
    cursor: pointer;
  }

  .navBtn {
    display: inline-block;
    width: calc(100% - 690px);
    text-align: right;
    margin-bottom: 10px;
  }

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
